'use strict';
exports.__esModule = true;
exports.useSlotPlugs = void 0;
var lodash_1 = require('lodash');
var react_1 = require('react');
var ui_plugin_1 = require('ui-plugin');
var pluginStore_1 = require('./pluginStore');
function useSlotPlugs(slotName) {
  var _a = react_1.useState(function () {
      return pluginStore_1.getEnabledSlotPlugs(slotName);
    }),
    plugs = _a[0],
    setPlugs = _a[1];
  // Keep plugs in sync with slotName
  var lastSlotName = react_1.useRef(slotName);
  react_1.useEffect(
    function () {
      // Prevent setting plugs to state twice on mount
      if (slotName !== lastSlotName.current) {
        setPlugs(pluginStore_1.getEnabledSlotPlugs(slotName));
        lastSlotName.current = slotName;
      }
    },
    [slotName],
  );
  react_1.useEffect(
    function () {
      return ui_plugin_1.onPluginLoad(function () {
        var newPlugs = pluginStore_1.getEnabledSlotPlugs(slotName);
        if (!lodash_1.isEqual(newPlugs, plugs)) setPlugs(newPlugs);
      });
    },
    [plugs, slotName],
  );
  return plugs;
}
exports.useSlotPlugs = useSlotPlugs;
